import React, { useState, useEffect } from 'react'
import { useApplicationContext } from '../provider'
import { Badge, V2ClockIcon } from '@paypalcorp/pp-react'

import Layout from './layout.js'
// import Banner from "./banner.js";

import NotificationBanner from '../components/layout/Home/Sections/NotificationBanner'
import Banner from '../components/layout/Home/Sections/Banner'
import AcceptPayments from '../components/layout/Home/Sections/AcceptPayments'
import MakePayments from '../components/layout/Home/Sections/MakePayments'
import AdditionalSolutions from '../components/layout/Home/Sections/AdditionalSolutions'
import Explore from '../components/layout/Home/Sections/Explore'
import Resources from '../components/layout/Home/Sections/Resources'
import HomeFooter from '../components/layout/Home/Sections/Footer'

function Home({ location }) {
  // Get local storage to see if user dismissed the banner
  const [isBannerHidden, setIsBannerHidden] = useState(false)
  const { experiments } = useApplicationContext()

  useEffect(() => {
    let hasHiddenBanner
    if (typeof window !== 'undefined') {
      hasHiddenBanner = localStorage.getItem('bannerHidden')
      setIsBannerHidden(hasHiddenBanner === 'true')
    }
  }, [])

  // Handle click event
  const handleDismiss = () => {
    typeof window !== `undefined` && localStorage.setItem('bannerHidden', true)
    setIsBannerHidden(true)
  }

  return (
    <Layout
      layout="full-width"
      leftNavBar={false}
      location={location}
      inverseHeaderScheme={true}
    >
      <section className="homepage-cov19">
        {!isBannerHidden && (
          <NotificationBanner handleDismiss={handleDismiss} />
        )}
        <Banner />
        <div
          className="topGraphic-wrapper"
          style={{
            margin: '3rem auto 0',
            maxWidth: '72rem',
            padding: '0 2.25rem',
          }}
        >
          {experiments.integrationBuilder && (
            <div
              className="checkoutWrapper"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Badge
                type="feature"
                leftIcon={V2ClockIcon}
                leftIconLabel="V2ClockIcon"
                className="new-badge"
              >
                New
              </Badge>
              <p
                className="badgeInfo newia-badge"
                style={{ display: 'flex', marginTop: '0' }}
              >
                Explore our Checkout code with the interactive Integration
                Builder.
                <a
                  href="/integration-builder"
                  style={{ display: 'block', marginLeft: '5px' }}
                >
                  Try it now
                </a>
              </p>
            </div>
          )}
        </div>
        <AcceptPayments />
        <MakePayments />
        <AdditionalSolutions />
        <Explore />
        <Resources />
        <HomeFooter />
      </section>
    </Layout>
  )
}

export default Home
